import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { environment } from '../../../../../environments/environment';
import { NewRepApplication } from '../new-rep-application-models/new-rep-application.model';

@Injectable({
  providedIn: 'root'
})
export class NewRepApplicationService {
  saveLicensingData(payload: { onboardingId: number; qualifications: any; }) {
    throw new Error('Method not implemented.');
  }

  private sessionStorageService = inject(SessionStorageService);
  constructor() { }

  async getDropdownOptions() {

    const API_URL: string = environment.baseUrl + environment.apis.getDropdownOptions;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewApplicationDetails(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.viewApplicationDetails;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "id": viewid
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async savenewapplicationDetails(newrepapplication: NewRepApplication) {

    const API_URL: string = environment.baseUrl + environment.apis.savenewapplicationDetails;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: newrepapplication.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async deleteQualification(id: number) {
    const API_URL: string = environment.baseUrl + environment.apis.deletequalification;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        id: id
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async deletemploymenthistory(id: number) {
    const API_URL: string = environment.baseUrl + environment.apis.deletemploymenthistory;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        id: id
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async deletedocument(data: any) {
    const API_URL: string = environment.baseUrl + environment.apis.deletedocument;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboardingId: data.onboardingId,
        docTypeId: data.docTypeId,
        id: data.id
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async downloadForms(data: any) {
    const API_URL: string = environment.baseUrl + environment.apis.downloadForms;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      responseType: 'blob',
      headers: {
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        filePath: data.filepath,
        fileName: data.filename
      }
    };
    await axios.request(REQUEST_CONFIG)
      .then((response) => {
        const blob = new Blob([response.data]);
        const objectUrl = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = data.filename;
        a.click();

        URL.revokeObjectURL(objectUrl);
      })
      .catch(error => {
        console.error('Download error:', error);
      });
  }

  async uploadDocuments(formData: FormData) {

    const API_URL: string = environment.baseUrl + environment.apis.uploadnewapplicationDocument;

    formData.append('UpdateByRole', this.sessionStorageService.getCurrentUserRole());
    
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      url: API_URL,
      headers: {
        Authorization: this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: formData
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async previewdocuments(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.viewchecklistdocuments + `/${viewid}`;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/pdf',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return new Blob([httpResponse.data], {
          type: 'application/pdf'
        });
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
}
